import { FC, useId } from 'react'
import styled from 'styled-components'

import { OptionCheckbox, TypeStyle } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { inputFillsAncestor } from '../../../primitives/shared-form-styles'
import { ValidationMessage } from '../../../primitives/ValidationMessage/ValidationMessage'

export type LogoRightsCheckboxProps = {
  checked: boolean
  onChange(checked: boolean): void
  errorMessage?: string
}

export const LogoRightsCheckbox: FC<LogoRightsCheckboxProps> = ({
  checked,
  onChange,
  errorMessage,
}) => {
  const {
    embroidery: {
      modal: {
        forms: {
          dtcLogoEmbroideryForm: { termsOfServiceNoLinks },
        },
      },
    },
  } = useTranslation()

  const errorId = useId()

  return (
    <div>
      <RightsCheckbox
        name='logoRights'
        type='checkbox'
        value='accepted'
        checked={checked}
        onChange={event => onChange(event.target.checked)}
        aria-describedby={errorMessage === undefined ? undefined : errorId}
        aria-invalid={errorMessage !== undefined}
      >
        <Terms>{termsOfServiceNoLinks}</Terms>
      </RightsCheckbox>

      <ValidationMessage id={errorId} message={errorMessage} />
    </div>
  )
}

const Terms = styled(TypeStyle.HeadlineMicro)`
  font-weight: ${o => o.theme.typography.font.weight[400]};
  line-height: 20px;
  text-transform: none;
`

const RightsCheckbox = styled(OptionCheckbox)`
  position: relative;

  ${inputFillsAncestor}
`
